exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-compare-btn[data-v-e44622b6]{padding:5px;white-space:nowrap;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;min-width:0;background-color:#fff;border:1px solid #ff8100;color:#ff8100}\n", ""]);

// exports
